import { vNodeCreate } from './vNode.create';
import { vNodeMount } from './vNode.mount';
import { vNodeUnmount } from './vNode.unmount';
import { vNodePatch } from './vNode.patch';
export const vNode = {
    create: vNodeCreate,
    mount: vNodeMount,
    unmount: vNodeUnmount,
    patch: vNodePatch
};
